module.exports = __webpack_public_path__ + "static/media/dog.540b06cd.svg";